import templateUrl from 'emun.commissioning/invoices/vendor-invoice-list.htm'
import controller from 'emun.commissioning/invoices/vendor-invoice-list.controller'

let VendorInvoiceList = {
    bindings: {
        orderId: '@'
    },
    controller,
    templateUrl($element, $attrs) {
        return $attrs.templateUrl || templateUrl
    }
}

export default VendorInvoiceList;